import { createdATFilter } from 'modules/common/constants';

export const faqFilters = [createdATFilter];
